"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationSiteV2ToJSON = exports.OrganizationSiteV2FromJSONTyped = exports.OrganizationSiteV2FromJSON = exports.instanceOfOrganizationSiteV2 = void 0;
var runtime_1 = require("../runtime");
var Address_1 = require("./Address");
var HighAvailabilityChoices_1 = require("./HighAvailabilityChoices");
/**
 * Check if a given object implements the OrganizationSiteV2 interface.
 */
function instanceOfOrganizationSiteV2(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "ipSubnets" in value;
    isInstance = isInstance && "switches" in value;
    isInstance = isInstance && "maxIspBandwidthPurchased" in value;
    isInstance = isInstance && "clientVpnServices" in value;
    isInstance = isInstance && "proxy" in value;
    isInstance = isInstance && "authenticationServer8021x" in value;
    isInstance = isInstance && "isThirdPartySite" in value;
    isInstance = isInstance && "timeZone" in value;
    isInstance = isInstance && "logSourceForwardSite" in value;
    isInstance = isInstance && "adDomainControllers" in value;
    isInstance = isInstance && "haFirewallType" in value;
    isInstance = isInstance && "firewalls" in value;
    isInstance = isInstance && "dns" in value;
    isInstance = isInstance && "dhcp" in value;
    return isInstance;
}
exports.instanceOfOrganizationSiteV2 = instanceOfOrganizationSiteV2;
function OrganizationSiteV2FromJSON(json) {
    return OrganizationSiteV2FromJSONTyped(json, false);
}
exports.OrganizationSiteV2FromJSON = OrganizationSiteV2FromJSON;
function OrganizationSiteV2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uuid': !(0, runtime_1.exists)(json, 'uuid') ? undefined : json['uuid'],
        'name': json['name'],
        'address': (0, Address_1.AddressFromJSON)(json['address']),
        'ipSubnets': json['ip_subnets'],
        'switches': json['switches'],
        'maxIspBandwidthPurchased': json['max_isp_bandwidth_purchased'],
        'clientVpnServices': json['client_vpn_services'],
        'proxy': json['proxy'],
        'authenticationServer8021x': json['authentication_server_8021x'],
        'isThirdPartySite': json['is_third_party_site'],
        'timeZone': json['time_zone'],
        'logSourceForwardSite': json['log_source_forward_site'],
        'adDomainControllers': json['ad_domain_controllers'],
        'haFirewallType': (0, HighAvailabilityChoices_1.HighAvailabilityChoicesFromJSON)(json['ha_firewall_type']),
        'firewalls': json['firewalls'],
        'dns': json['dns'],
        'dhcp': json['dhcp'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
        'inventory': !(0, runtime_1.exists)(json, 'inventory') ? undefined : json['inventory'],
    };
}
exports.OrganizationSiteV2FromJSONTyped = OrganizationSiteV2FromJSONTyped;
function OrganizationSiteV2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uuid': value.uuid,
        'name': value.name,
        'address': (0, Address_1.AddressToJSON)(value.address),
        'ip_subnets': value.ipSubnets,
        'switches': value.switches,
        'max_isp_bandwidth_purchased': value.maxIspBandwidthPurchased,
        'client_vpn_services': value.clientVpnServices,
        'proxy': value.proxy,
        'authentication_server_8021x': value.authenticationServer8021x,
        'is_third_party_site': value.isThirdPartySite,
        'time_zone': value.timeZone,
        'log_source_forward_site': value.logSourceForwardSite,
        'ad_domain_controllers': value.adDomainControllers,
        'ha_firewall_type': (0, HighAvailabilityChoices_1.HighAvailabilityChoicesToJSON)(value.haFirewallType),
        'firewalls': value.firewalls,
        'dns': value.dns,
        'dhcp': value.dhcp,
        'notes': value.notes,
        'inventory': value.inventory,
    };
}
exports.OrganizationSiteV2ToJSON = OrganizationSiteV2ToJSON;
